import { asyncRouterMap, constantRouterMap } from '@/router/index';

// Presentation only. Identity, permissions, visibility, ordering and paths still
// come from the existing route/menu matching below.
const integrationDisplayTitles = {
  integrationManagement: '接入管理',
  integrationClients: '接入系统',
  integrationOutbox: '通知发送记录',
  integrationReconciliation: '发布通知维护',
  integrationBuilds: '算法包管理'
}

//判断是否有权限访问该菜单
function hasPermission(menus, route) {
  if (route.name) {
    let currMenu = getMenu(route.name, menus);
    if (currMenu!=null) {
      //设置菜单的标题、图标和可见性
      if (Object.prototype.hasOwnProperty.call(integrationDisplayTitles, route.name)) {
        route.meta.title = integrationDisplayTitles[route.name];
      } else if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.title !== '') {
        route.meta.icon = currMenu.icon;
      }
      if(currMenu.hidden!=null){
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort;
      }
      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        return true;
      } else {
        return false;
      }
    }
  } else {
    return true
  }
}

//根据路由名称获取菜单
function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name===menu.name) {
      return menu;
    }
  }
  return null;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if(router.children && router.children.length > 0){
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p){
  return function(m,n){
    let a = m[p];
    let b = n[p];
    return b - a;
  }
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menus } = data;
        const { username } = data;
        const accessedRouters = asyncRouterMap.map(route => {
          // Integration 子菜单因 USER 授权而异，不能裁剪下一次登录复用的路由定义。
          if (route.name !== 'integrationManagement') return route;
          return {
            ...route,
            meta: { ...route.meta },
            children: route.children.map(child => ({ ...child, meta: { ...child.meta } }))
          };
        }).filter(v => {
          //admin帐号直接返回所有菜单
          // if(username==='admin') return true;
          if (hasPermission(menus, v) || (v.name === 'integrationManagement' && getMenu('integrationBuilds', menus))) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter(child => {
                if (hasPermission(menus, child)) {
                  return child
                }
                return false;
              });
              if (v.name === 'integrationManagement') {
                const entry = v.children.find(child => child.name === 'integrationClients' && !child.hidden)
                  || v.children.find(child => !child.hidden);
                if (!entry) return false;
                v.redirect = v.path + '/' + entry.path;
              }
              return v
            } else {
              return v
            }
          }
          return false;
        });
        //对菜单进行排序
        sortRouters(accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      })
    }
  }
};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js